// extracted by mini-css-extract-plugin
module.exports = {"baseRoot":"baseRoot___3Q93C","main":"main___kF_lJ","contentDiv":"contentDiv___2f9o1","pSpan1":"pSpan1___1u8NE","pSpan2":"pSpan2___3bIoi"};